import {AppContext} from "../../lib/AppContext";
import React, {useContext} from "react";
import {formatCurrency} from "../common/Utils";
import {Divider, Grid} from "@mui/material";
import {clientUpdateCart} from "../common/api/CartApi";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import Avatar from "@mui/material/Avatar";

export default function ClientCartInventoryEventMemberships({client, cartItem, memberships, handleSave}) {
  const [context, setContext] = useContext(AppContext);

  const loadCartFn = () => {

    let _context = {...context};
    _context.reloadCart = true;
    _context.toast = {
      message: 'Added to cart!',
      type: 'success'
    }
    setContext({..._context});
  };

  const addToCartFn = async (inventory) => {
    let _req = {};
    _req.cartItem = {...cartItem};
    _req.inventory = {...inventory};

    clientUpdateCart(_req, client?.guid).then(resp => {
      handleSave(resp)
    });
  };

  return (
    <>
      <MDBox p={3}>
        <MDBox>
          {memberships?.length > 0 && <>
            {memberships?.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
              // .filter(item => showEvent(item))
              .map((inventory, index) => {
                return (
                  <div key={index}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={9}>
                        <h6>{inventory.name}</h6>
                        {inventory?.accountType?.siblingOptionsEnabled && <>
                          <p><b><small>Discount Sibling Rate</small></b></p>
                        </>}
                        <p><small>
                          {inventory.accountType?.name}
                        </small><br/>
                          <small className={inventory?.accountType?.siblingOptionsEnabled ? 'text-decoration-line-through' : ''}>
                            {formatCurrency(inventory?.price)}
                          </small>
                          {inventory?.accountType?.siblingOptionsEnabled && <small>
                            <br/>
                            {formatCurrency(inventory.discountPrice)}
                          </small>}

                        </p>
                        <p>
                          <small>
                            {inventory.desc}
                          </small>
                        </p>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <MDBox display="flex" justifyContent="flex-end">
                          <Avatar alt={inventory?.name}
                                  className={'pull-left m-3'}
                                  sx={{width: 96, height: 96}}>
                            {inventory?.imageUrl && <img src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                 style={{width: '200%', height: 'auto'}}
                                 alt={inventory?.name}/> }
                          </Avatar>
                        </MDBox>
                        {
                          <MDBox display="flex" justifyContent="flex-end">
                            <MDButton
                                      size={'small'}
                                      color="info"
                                      onClick={(e) => {
                                        addToCartFn(inventory);
                                      }}>Add To Cart</MDButton>
                          </MDBox>
                        }
                      </Grid>
                    </Grid>
                    <Divider/>
                  </div>
                )
              })
            }
          </>}
        </MDBox>
      </MDBox>
    </>
  )
}